import { render, staticRenderFns } from "./avance-modificaciones.vue?vue&type=template&id=18175e83&scoped=true&"
import script from "./avance-modificaciones.vue?vue&type=script&lang=js&"
export * from "./avance-modificaciones.vue?vue&type=script&lang=js&"
import style0 from "./avance-modificaciones.vue?vue&type=style&index=0&id=18175e83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18175e83",
  null
  
)

export default component.exports